import axios from "axios";

export default {
    namespaced: true,

    state: {
        configurationData: localStorage.getItem("configuration") ? JSON.parse(localStorage.getItem("configuration")) : null,
    },

    getters: {
        configuration: state => state.configurationData,
    },

    mutations: {
        setConfigurationData(state, config) {
            state.configurationData = config;
        }
    },

    actions: {
        getConfigurationData({ commit }) {
            const identifier = localStorage.getItem('agencyIdentifier');
            const urlImage = process.env.VUE_APP_URL_BEST_API;
            axios
                .get(`/${identifier}/configuration`)
                .then(response => {
                    let body = {
                        address: response.data.data.address,
                        decimal_amount: response.data.data.decimal_amount,
                        enabled: response.data.data.enabled,
                        identifier: response.data.data.identifier,
                        agency_owner: response.data.data.agency_owner,
                        image: urlImage + response.data.data.image,
                        name: response.data.data.name,
                        usd: response.data.setting.usd,
                        sending_email: response.data.data.sending_email,
                        direct_model: response.data.data.direct_model,
                    };

                    commit("setConfigurationData", body);
                    localStorage.setItem("configuration", JSON.stringify(body));
                })
                .catch(() => {
                    //localStorage.removeItem("authToken");
                });
        },
    }
};
